export default __webpack_public_path__ + "static/media/north.84a89c66.png";